export default __webpack_public_path__ + "images/0f3e4e9d2cd6c957c6d7b5eb4cd5ec04.png";